import axios from 'axios'
import ErrorHandlingInterceptor from '@/api/interceptors/errorHandler'
import ObjectHelper from '@/helpers/objectHelper'
import { passThroughAxios } from '@/api/server/passThrough.axios'

export default {
  async setFinancing(params) {
    try {
      const {
        quoteId,
        channel,
        productType,
        objectType,
        objectPriceExVATExBPM,
        objectPriceInclVATInclBPM,
        objectPriceVAT,
        downPayment,
        balloonPayment,
        duration,
      } = params

      if (quoteId) {
        const response = await axios.post(`/vwpfs/${quoteId}/financing`, {
          channel,
          productType,
          objectType,
          objectPriceExVATExBPM,
          objectPriceInclVATInclBPM,
          objectPriceVAT,
          downPayment,
          balloonPayment,
          duration,
        })
        return response.data?.vehicle?.price?.financingPriceCalculation?.price
      } else {
        Promise.reject()
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async requestSilva(params) {
    try {
      const { quoteId, durationMonths } = params
      const response = await axios.get(
        `/vwpfs/${quoteId}/financing/silva` +
          (durationMonths ? `?durationMonths=${durationMonths}` : '')
      )
      // In case for some reason no url is returned but there is no error status/message
      if (!response.data?.Url) {
        const error = response.data?.Errors ? response.data.Errors : 'No url returned'
        window.VUE_CLI_EXPORTS.plugins.EventBus.$emit('notification-warning', error)
        throw error
      }
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async setPrivateLease(params, save = false) {
    try {
      const { quoteId, plCalculationParameters, leaseProductDiscounts } = params
      const privateLeaseInstance = axios.create()

      // Suppress all notifications since we handle them manually in the component
      privateLeaseInstance.interceptors.response.use(
        ErrorHandlingInterceptor.responseSuccessInterceptor,
        ErrorHandlingInterceptor.suppressAllNotificationsInterceptor
      )

      if (quoteId) {
        const path = `/vwpfs/${quoteId}/privatelease` + (save !== null ? `?save=${save}` : '')
        const response = await privateLeaseInstance.post(path, {
          plCalculationParameters,
          leaseProductDiscounts,
        })
        return response.data
      } else {
        Promise.reject()
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async setOperationalLease(params, save = false) {
    try {
      const { quoteId, plCalculationParameters, leaseProductDiscounts } = params
      const operationalLeaseInstance = axios.create()

      // Suppress all notifications since we handle them manually in the component
      operationalLeaseInstance.interceptors.response.use(
        ErrorHandlingInterceptor.responseSuccessInterceptor,
        ErrorHandlingInterceptor.suppressAllNotificationsInterceptor
      )

      if (quoteId) {
        const path = `/vwpfs/${quoteId}/operationallease` + (save !== null ? `?save=${save}` : '')
        const response = await operationalLeaseInstance.post(path, {
          plCalculationParameters,
          leaseProductDiscounts,
        })
        return response.data
      } else {
        Promise.reject()
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },

  // Calculates the premium for any insurance provider.
  async setInsurance(params) {
    try {
      const {
        quoteId,
        policyHolder,
        contract,
        vehicle,
        coverages,
        coverageOption,
        parametersAccepted,
      } = params

      if (!quoteId) return Promise.reject()

      // coverageOption is the configured main-coverage option key; PCQM stores it with the call.
      const response = await passThroughAxios.post(`insurance/${quoteId}/calculate`, {
        insurance: {
          policyHolder,
          contract,
          vehicle,
          coverages,
        },
        ...(coverageOption ? { coverageOption } : {}),
        ...(parametersAccepted ? { parametersAccepted: true } : {}),
      })
      return ObjectHelper.keysToCamelCase(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  // Returns the active insurance provider configuration for the dealer.
  async getInsuranceConfiguration() {
    try {
      const response = await passThroughAxios.get('insurance/configuration')
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
